export const KR_STATUS_COLORS: Record<string, string> = {
  on_track: '#3AC47D',
  at_risk: '#FBC02D',
  off_track: '#F44336',
  completed: '#6C30CC',
};

export const KR_STATUS_LABELS: Record<string, string> = {
  on_track: 'On Track',
  at_risk: 'At Risk',
  off_track: 'Off Track',
  completed: 'Completed',
};
